import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <section id="sobre" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="animate-slide-right">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              {t('aboutTitle')}
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              {t('aboutDesc1')}
            </p>
            <p className="text-lg text-gray-600 mb-6">
              {t('aboutDesc2')}
            </p>
            <div className="space-y-4">
              <div className="flex items-center hover-lift">
                <i className="ri-check-double-line text-orange-500 text-xl mr-3"></i>
                <span className="text-gray-700">{t('aboutFeature1')}</span>
              </div>
              <div className="flex items-center hover-lift">
                <i className="ri-check-double-line text-orange-500 text-xl mr-3"></i>
                <span className="text-gray-700">{t('aboutFeature2')}</span>
              </div>
              <div className="flex items-center hover-lift">
                <i className="ri-check-double-line text-orange-500 text-xl mr-3"></i>
                <span className="text-gray-700">{t('aboutFeature3')}</span>
              </div>
              <div className="flex items-center hover-lift">
                <i className="ri-check-double-line text-orange-500 text-xl mr-3"></i>
                <span className="text-gray-700">{t('aboutFeature4')}</span>
              </div>
            </div>
          </div>

          <div className="relative animate-slide-left">
            <img
              src="https://public.readdy.ai/ai/img_res/8d682ad375250e9836527e8be67c06f9.jpg"
              alt="Cliente Executiva FARWAYS"
              className="rounded-2xl shadow-xl object-cover object-top w-full h-96 hover-lift"
            />
            <div className="absolute -bottom-6 -left-6 bg-orange-500 text-white p-6 rounded-xl shadow-lg animate-scale-in">
              <div className="text-3xl font-bold">{t('aboutStat2')}</div>
              <div className="text-sm">{t('yearsLabel')}</div>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center animate-fade-in hover-lift">
            <div className="text-4xl font-bold text-orange-500 mb-2">
              {t('aboutStat1')}
            </div>
            <div className="text-gray-600 font-medium">
              {t('aboutStat1Label')}
            </div>
          </div>
          <div className="text-center animate-fade-in hover-lift" style={{ animationDelay: '0.1s' }}>
            <div className="text-4xl font-bold text-orange-500 mb-2">
              {t('aboutStat2')}
            </div>
            <div className="text-gray-600 font-medium">
              {t('aboutStat2Label')}
            </div>
          </div>
          <div className="text-center animate-fade-in hover-lift" style={{ animationDelay: '0.2s' }}>
            <div className="text-4xl font-bold text-orange-500 mb-2">
              {t('aboutStat3')}
            </div>
            <div className="text-gray-600 font-medium">
              {t('aboutStat3Label')}
            </div>
          </div>
          <div className="text-center animate-fade-in hover-lift" style={{ animationDelay: '0.3s' }}>
            <div className="text-4xl font-bold text-orange-500 mb-2">
              {t('aboutStat4')}
            </div>
            <div className="text-gray-600 font-medium">
              {t('aboutStat4Label')}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
